'use client'
import StickerCard from '@/components/home-page/StickerCard';
import Carousel from '@avtopro/carousel/dist/index';

interface StickerCardsProps {
	heading: string;
	cards: {
		icon: string;
		alt: string;
		title: string;
		text: string;
	}[]
}
const StickerCardsSection = ({cards, heading}: StickerCardsProps) => {

	return (
		<section>
			<h2 className="h2 mb-3 md:mb-4">{heading}</h2>
			<Carousel containerComponent={'ul'} showEdgesShadow options={{ dragFree: true }}>
				{cards.map((item) => (
					<li key={item.alt} className="card-item">
						<StickerCard
							icon={{ src: item.icon, alt: item.alt }}
							title={item.title}
							text={item.text}
						/>
					</li>
				))}
			</Carousel>
		</section>
	);
};
export default StickerCardsSection;